<template>
    <div>
        <ValidationObserver slim ref="form">
            <form @submit.prevent="onSubmit">

                <div class="col2 form-item" v-show="!success">
                    <p>
                        <label for="prenom">Prénom*</label>
                        <ValidationProvider slim name="field_prenom" rules="required" v-slot="{ classes, errors }">
                            <input type="text" name="prenom" id="prenom" :class="classes" v-model="item.prenom"/>
                            <span class="error-txt">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </p>

                    <p>
                        <label for="nom">Nom*</label>
                        <ValidationProvider slim name="field_nom" rules="required" v-slot="{ classes, errors }">
                            <input type="text" name="nom" id="nom" :class="classes" v-model="item.nom"/>
                            <span class="error-txt">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </p>
                </div>

                <div class="col1 form-item" v-show="!success">
                    <p>
                        <ValidationProvider slim name="sujet" rules="required" v-slot="{ classes, errors }">
                            <select name="sujet" id="sujet" :class="classes" v-model="item.sujet">
                                <option value="null">Votre question concerne ?*</option>
                                <option :value="key" v-for="(subject, key) in contact_subjects">{{ subject }}</option>
                            </select>
                            <span class="error-txt">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </p>
                </div>


                <div class="col1 form-item" v-show="!success">
                    <p>
                        <ValidationProvider slim name="message" rules="required" v-slot="{ classes, errors }">
                            <textarea name="message" placeholder="Bonjour, ..." :class="classes"
                                      v-model="item.message"></textarea>
                            <span class="error-txt">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </p>
                </div>

                <div class="recaptcha" v-show="!success">
                    <vue-recaptcha :sitekey="recaptcha_site_key"
                                   ref="googleRecaptcha"
                                   @verify="markRecaptchaAsVerified"
                    ></vue-recaptcha>
                    <p class="error-txt" v-if="recaptchaError">{{ recaptchaError }}</p>
                </div>

                <div class="form-item" v-show="!success">
                    <input type="submit" name="submit" id="submit" value="envoyer"/>
                </div>

                <p class="error-txt" v-if="error">{{ error }}</p>
                <p class="success-txt" v-if="success" v-html="success"></p>
            </form>
        </ValidationObserver>
    </div>
</template>
<script>
import VueRecaptcha from "vue-recaptcha";
import User from "../../services/User";
import Contact from "../../services/Contact";

export default {
    props: ['recaptcha_site_key', 'contact_subjects'],
    components: {VueRecaptcha},
    data() {
        return {
            error: null,
            success: null,
            recaptchaVerified: false,
            recaptchaError: null,
            item: {
                prenom: null,
                nom: null,
                sujet: null,
                message: null,
            }
        }
    },
    created() {
        User.me().then((user) => {
            this.item.prenom = user.field_prenom;
            this.item.nom = user.field_nom;
        });
    },
    mounted() {

    },
    methods: {
        markRecaptchaAsVerified(response) {
            this.recaptchaVerified = true;
            this.item.recaptcha_token = response;
        },
        onSubmit() {
            this.error = this.success = this.recaptchaError = null;
            this.$refs.form.validate().then(success => {

                if (!this.recaptchaVerified) {
                    this.recaptchaError = 'Merci de valider le Captcha.';
                    success = false;
                }

                if (!success) {
                    return;
                }

                this.sendContact();
            });
        },
        sendContact() {
            Contact.send(this.item).then((response) => {
                this.success = response.success;

                // Redirect
                // this.success = this.success + "<br />Vous allez être rediriger vers la page d\'accueil dans quelques secondes...";
                // setTimeout(() => {
                //     window.location.href = window.drupalSettings.path.baseUrl;
                // }, 3000);
            }).catch((error) => {
                this.error = error.error;

                // reset Re-captcha
                this.recaptchaVerified = false;
                this.$refs.googleRecaptcha.reset();
            });
        }
    }
}
</script>
